import type { PropsWithChildren } from 'react';
import './styles/reportPreview.compiled.css';

/**
 * Loads report preview styles (Reema theme, report layout, scoped Tailwind) once.
 * @param children - Section renderer output.
 */
export const ReportPreviewShell = ({ children }: PropsWithChildren) => {
  return <div className="report-preview-root">{children}</div>;
};
